import React, { useEffect } from 'react';
import { Input, InputTextArea } from '@brokerbay/elements-web';
import { AccessOptionProps } from '../../types';
import UploadEditPhotoButton from '../UploadEditPhotoButton';

const CombinationLockBox: React.FC<AccessOptionProps> = ({
  listing,
  showingsConfig,
  showValidationError,
  setShowingsConfig,
  setIsValid,
}) => {
  const isDetailsFilled =
    Boolean(showingsConfig.instructions.lockbox?.code) ||
    Boolean(showingsConfig.instructions.lockbox?.details);

  useEffect(() => {
    setIsValid(isDetailsFilled);
  }, [isDetailsFilled, setIsValid]);

  return (
    <>
      <div>
        <Input
          label="Lock Box Instructions"
          dataCy="showing-notification-lockbox-instructions"
          value={showingsConfig.instructions.lockbox?.code || ''}
          required
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                lockbox: {
                  details: '',
                  ...(prev.instructions.lockbox || {}),
                  code: value,
                },
              },
            }))
          }
          error={
            showValidationError && !isDetailsFilled
              ? 'Details are required'
              : undefined
          }
        />
      </div>
      <div>
        <UploadEditPhotoButton
          listingId={listing.id}
          lockboxPhoto={showingsConfig.lockboxPhoto}
          setLockboxPhoto={val => {
            setShowingsConfig(prev => ({
              ...prev,
              lockboxPhoto: val,
            }));
          }}
        />
      </div>
      <div>
        <InputTextArea
          label="Access instructions"
          required
          dataCy="showing-notification-access-instructions"
          minHeight={100}
          value={showingsConfig.instructions.lockbox?.details || ''}
          onChange={value =>
            setShowingsConfig(prev => ({
              ...prev,
              instructions: {
                ...prev.instructions,
                lockbox: {
                  code: '',
                  ...(prev.instructions.lockbox || {}),
                  details: value,
                },
              },
            }))
          }
          error={
            showValidationError && !isDetailsFilled
              ? 'Details are required'
              : undefined
          }
        />
      </div>
    </>
  );
};

export default CombinationLockBox;
